import React from 'react';

const Target = ({ className }) => {
    return (
        <svg className={className} viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg">
            <g transform="matrix(.99998 0 0 .99998 -35.004 -84.998)" strokeWidth="1.3906">
                <g strokeWidth="1.3906">
                    <circle cx="100" cy="150" r="57.5" style={{ paintOrder: 'markers stroke fill' }}></circle>
                    <g strokeWidth="1.3906">
                        <circle cx="100" cy="150" r="23.75" fill="#fff" style={{ paintOrder: 'markers stroke fill' }}></circle>
                        <circle cx="100" cy="150" r="22.5" style={{ paintOrder: 'markers stroke fill' }}></circle>
                    </g>
                </g>
                <g fill="none">
                    <path d="m100 72.515v154.97" stroke="#a3a3a3" strokeDasharray="1.1055, 1.1055" strokeOpacity=".42284" strokeWidth=".3685"></path>
                    <path d="m177.49 150h-154.97" stroke="#a3a3a3" strokeDasharray="1.1055, 1.1055" strokeOpacity=".42284" strokeWidth=".3685"></path>
                    <g stroke="#ff6b1f">
                        <path d="m100 147.71v4.583" strokeWidth=".36792"></path>
                        <path d="m102.29 150h-4.583" strokeWidth=".36792"></path>
                        <ellipse cx="99.999" cy="150" rx="11.149" ry="11.15" strokeDasharray="0.837706, 0.837706" strokeLinecap="square" strokeLinejoin="round" strokeWidth=".27924" style={{ paintOrder: 'markers stroke fill' }}></ellipse>
                        <ellipse cx="100" cy="150" rx="39.9" ry="39.901" strokeDasharray="0.83434, 0.83434" strokeLinecap="square" strokeLinejoin="round" strokeWidth=".27811" style={{ paintOrder: 'markers stroke fill' }}></ellipse>
                    </g>
                    <ellipse cx="99.999" cy="150" rx="19.741" ry="19.749" stroke="#396bb5" strokeDasharray="0.83434, 0.83434" strokeLinecap="square" strokeLinejoin="round" strokeWidth=".27811" style={{ paintOrder: 'markers stroke fill' }}></ellipse>
                    <circle cx="99.999" cy="150" r="54.9" stroke="#396bb5" strokeDasharray="0.834895, 0.834895" strokeLinecap="square" strokeLinejoin="round" strokeWidth=".2783" style={{ paintOrder: 'markers stroke fill' }}></circle>
                </g>
            </g>
        </svg>
    );
};

export default Target;